<template>
  <div>
    <OrderedItemBaseCard
      :name="merch.name"
      :original-price="displayedOriginalPrice"
      :current-price="itemPrice"
      :clear="showClearButton && !item.isNotAllowedSelect && !isBelongAddOn(item) && merch.editable"
      :show-deal="merch.currentPrice != merch.originalPrice"
      :quantity="item.quantity"
      :show-quantity-badge="false"
      :show-quantity-controls="showQuantityControls"
      @clear="removeItem"
      @increaseQuantity="increaseQuantity"
      @decreaseQuantity="decreaseQuantity"
    >
      <template #original-price>
        <p 
          class="final-price" 
          :class="[
            item.isNotAllowedSelect || isBelongAddOn(item) ? 'mr-8': 'mr-2.5',
            merch.currentPrice != merch.originalPrice ? 'grey-strikethru':''
            ]"
        >
          {{ currencySymbol + displayedOriginalPrice.toFixed(2) }}
        </p>
      </template>
    </OrderedItemBaseCard>
  </div>
</template>

<script>
//import PanelCardAllTest from "../AllTestsPannel/PannelCard_AllTest.vue";
// import TestSuggestionDialog from "./TestAddOnSuggestion/TestSuggestionDialog.vue";
import OrderedItemBaseCard from "./OrderedItemBaseCard.vue";
import { mapState, mapGetters } from "vuex";
import { removeItemInSelectedItemList } from "../order-page/order-summary/selected-tests-tab-pane/index.js";

export default {
  components: {
    OrderedItemBaseCard,
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    testPriceTotal:{
      type: Number,
      default: 0
    },
    originalPrice: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ""
    },
    isForMarkupDialog: {
      type: Boolean,
      default: false,
    },
    isShowEditMarkup: {
      type: Boolean,
      default: true
    },
    showClearButton: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      isShowIncludedTests: false,
      isShowTestSuggestionDialog: false,
      isShowMarkupEditDialog: false
    }
  },
  computed: {
    ...mapState(["currency"]),
    ...mapState("orderTest", ["testSuggestions","isAddOnOrder","addOnFixedVaVwTest","addOnFixedDiscountPanel","addOnFixedCustomPanel","addOnFixedVaVwTestWithParents"]),
    ...mapState("orderTest/user", ["userInfo"]),
    ...mapGetters("orderTest/order", ["isMarkupEligible"]),
    ...mapGetters("orderTest", ["selectedVwTestPrice", "orderTestSupportObj", "addOnselectedItemList"]),
    ...mapGetters("orderTest/panels", ["selectedXChooseYPanelList"]),
    
    currencySymbol() {
      return this.currency ? this.currency.symbol : "$";
    },

    merch() {
      return this.item.merch;
    },

    displayedOriginalPrice() {
      return this.merch.originalPrice * this.item.quantity;
    },
    
    itemPrice() {
      return this.item.quantity * this.merch.currentPrice;
    },

    showQuantityControls() {
      return !this.item.isNotAllowedSelect && !this.isBelongAddOn(this.item) && this.merch.editable && this.showClearButton;
    },

  },

  emits: ["removeItem"],

  methods: {
    removeItem() {
      this.$store.commit("orderTest/merchandise/REMOVE_ITEM_FROM_SELECTED_MERCH_MAP", this.item.id);
    },

    increaseQuantity() {
      this.$store.dispatch("orderTest/merchandise/addToSelectedMerchMap", this.item.id);
    },

    decreaseQuantity() {
      this.$store.dispatch("orderTest/merchandise/removeFromSelectedMerchMap", this.item.id);
    },

    isBelongAddOn(item) {
      let affectedAddOnDiscountBundle = false
      let affectedAddOnPromo = false
      let affectedAddOnXChooseY = false
      let affectedAddOnVaVwTest = false
      
      if(item.category === 'discountPanel') {
        let { packageList,testList } = item.bundleContent
        let testIdList = testList ? testList.map(t => t.testId) : [];
        let packageIdList = packageList ? packageList.map(p => p.packageId) : [];
        let bundleContentTesetIds = testIdList.concat(packageIdList)

        let addOnFixedVaVwTestKeys = Array.from(this.addOnFixedVaVwTest.keys())
        let addOnFixedVaVwTestValues = Array.from(this.addOnFixedVaVwTest.values())
        
        if(addOnFixedVaVwTestKeys.concat(addOnFixedVaVwTestValues).some(x => bundleContentTesetIds.includes(x))) {
          affectedAddOnDiscountBundle = true
        }
        return this.addOnFixedDiscountPanel.has(item.bundleId) || affectedAddOnDiscountBundle
      }
      else if(item.category === 'seasonalPromo') {
        let addOnFixedVaVwTestKeys = Array.from(this.addOnFixedVaVwTest.keys())
        let addOnFixedVaVwTestValues = Array.from(this.addOnFixedVaVwTest.values())
        if(addOnFixedVaVwTestKeys.concat(addOnFixedVaVwTestValues).some(x => item.testIdsInPromo.has(x))) {
          affectedAddOnPromo = true
        }
        return affectedAddOnPromo
      }
      else if(item.category === 'xChooseY') {
        let addOnFixedVaVwTestKeys = Array.from(this.addOnFixedVaVwTest.keys())
        let addOnFixedVaVwTestValues = Array.from(this.addOnFixedVaVwTest.values())
        
        if(addOnFixedVaVwTestKeys.concat(addOnFixedVaVwTestValues)
          .some(x => (item.selectedZoomerIdList).includes(x) || (item.selectedSupplementIdList&&item.selectedSupplementIdList.includes(x)))) {
            affectedAddOnXChooseY = true
        }
        return affectedAddOnXChooseY
      }
      else if(item.category === 'va' || item.category === 'vw') {
        if(this.addOnFixedVaVwTestWithParents.get(item.id)) {
          affectedAddOnVaVwTest = true
        }
        return this.addOnFixedVaVwTest.has(item.id) || affectedAddOnVaVwTest
      }
      else if(item.category === 'customPanel') {
        return this.addOnFixedCustomPanel.includes(item.bundleId)
      } else {
        return false
      }
    },
  }
};
</script>

<style scoped>
.final-price {
  height: 16px;
  font-size: 14px;
  letter-spacing: 0.4px;
  line-height: 16px;
}

.grey-strikethru {
  color: grey;
  text-decoration: line-through;
}

.deal-price {
  height: 16px;
  color: #000000;
  font-family: Roboto;
  font-size: 14px;
  letter-spacing: 0.4px;
  line-height: 16px;
  /* margin-right: 31px; */
}

.unlocking-deal-container {
  background-color: rgba(132, 188, 59, 0.05);
  width: 349px;  
  height: 30px;
  padding-right: 8px;
}

.save-text{
  color: #FF1D00;
}
</style>
